/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Render_Audio_Rendering_EventsInputs */

const en_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendering ${i?.count} Selected Event(s)`)
};

const fr_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendu de ${i?.count} evenement(s) selectionne(s)`)
};

const de_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendering ${i?.count} Ausgewähltes(e) Ereignis(se)`)
};

const it_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendering ${i?.count} Evento/i selezionato/i`)
};

const ru_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отображение выбранного(ых) события(й) ${i?.count}`)
};

const es_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Representando ${i?.count} Evento(s) seleccionado(s)`)
};

const zh_cn2_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`渲染 ${i?.count} 选定事件`)
};

const ja_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 選択されたイベントをレンダリングしています`)
};

const hi_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं का रेंडरिंग ${i?.count}`)
};

const pt_pt2_render_audio_rendering_events = /** @type {(inputs: Render_Audio_Rendering_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Renderizando ${i?.count} Evento(s) selecionado(s)`)
};

/**
* | output |
* | --- |
* | "Rendering {count} Selected Event(s)" |
*
* @param {Render_Audio_Rendering_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_rendering_events = /** @type {((inputs: Render_Audio_Rendering_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Rendering_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_rendering_events(inputs)
	if (locale === "de") return de_render_audio_rendering_events(inputs)
	if (locale === "it") return it_render_audio_rendering_events(inputs)
	if (locale === "ru") return ru_render_audio_rendering_events(inputs)
	if (locale === "es") return es_render_audio_rendering_events(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_rendering_events(inputs)
	if (locale === "ja") return ja_render_audio_rendering_events(inputs)
	if (locale === "hi") return hi_render_audio_rendering_events(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_rendering_events(inputs)
	return en_render_audio_rendering_events(inputs)
});